import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { KeyRound, UserRound } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { adminApi } from '@/lib/api/endpoints';
import { userMessage } from '@/lib/api/errors';

export function AdminPasswordResetsPage() {
  const qc = useQueryClient();
  const requests = useQuery({ queryKey: ['admin', 'password-resets'], queryFn: adminApi.passwordResetRequests });
  const reset = useMutation({
    mutationFn: adminApi.resetRequestedPassword,
    onSuccess: () => {
      toast.success('Password reset. The temporary password is ?password?; the user must change it after signing in.');
      void qc.invalidateQueries({ queryKey: ['admin', 'password-resets'] });
    },
    onError: e => toast.error(userMessage(e)),
  });
  return <div className="space-y-6">
    <div><p className="text-sm font-semibold text-primary-ink">Admin</p><h1 className="mt-1 text-3xl font-extrabold">Password reset requests</h1>
      <p className="mt-2 text-muted-foreground">Verify the submitted name, email, and phone before resetting access.</p></div>
    {requests.isPending ? <p className="text-muted-foreground">Loading requests?</p> :
      requests.isError ? <p role="alert" className="text-destructive">{userMessage(requests.error)}</p> :
      requests.data.length === 0 ? <div className="rounded-xl border bg-card p-6 text-muted-foreground">No pending requests.</div> :
      <div className="space-y-3">{requests.data.map(r => <article key={r.id} className="flex flex-col gap-4 rounded-xl border bg-card p-5 sm:flex-row sm:items-center">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary-ink"><UserRound className="size-5" /></div>
        <div className="min-w-0 flex-1">
          <h2 className="font-bold">{r.full_name}</h2><p className="truncate text-sm text-muted-foreground">{r.email} ? {r.phone}</p>
          <p className="mt-1 text-xs text-muted-foreground">Submitted {new Date(r.created_at).toLocaleString()}</p>
        </div>
        <Button onClick={() => reset.mutate(r.id)} loading={reset.isPending} disabled={reset.isPending}><KeyRound /> Verify and reset</Button>
      </article>)}</div>}
    <p className="text-xs text-muted-foreground">The reset succeeds only when all three details match a registered account.</p>
  </div>;
}
